module.exports = __webpack_public_path__ + "img/1717486752664-WhatsApp Image 2024-06-04 at 14.24.04.jpeg.a33b8e08.webp";